var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholderImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_15009_18661)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 31.25V53.75C60 55.8203 58.3203 57.5 56.25 57.5H23.75C21.6797 57.5 20 55.8203 20 53.75V31.25C20 29.1797 21.6797 27.5 23.75 27.5H30.625L31.5859 24.9297C32.1328 23.4687 33.5312 22.5 35.0938 22.5H44.8984C46.4609 22.5 47.8594 23.4687 48.4062 24.9297L49.375 27.5H56.25C58.3203 27.5 60 29.1797 60 31.25ZM49.375 42.5C49.375 37.3281 45.1719 33.125 40 33.125C34.8281 33.125 30.625 37.3281 30.625 42.5C30.625 47.6719 34.8281 51.875 40 51.875C45.1719 51.875 49.375 47.6719 49.375 42.5ZM46.875 42.5C46.875 46.2891 43.7891 49.375 40 49.375C36.2109 49.375 33.125 46.2891 33.125 42.5C33.125 38.7109 36.2109 35.625 40 35.625C43.7891 35.625 46.875 38.7109 46.875 42.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15009_18661",
    x1: 0,
    y1: 0,
    x2: 80,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImg);
export default __webpack_public_path__ + "static/media/placeholder_img.b1b1952032f067f162c4218553326373.svg";
export { ForwardRef as ReactComponent };